<div class="recent-file-container" #container *ngIf="{ isMawChrome: selectedLauncher | isMawChromeLauncher } as launcher">

  <div class="funkyradio row no-gutters"
    [ngClass]="{'files-list' : playlistItem?.PlaylistItemLinks.length > 1, 'hiden-label' : launcher.isMawChrome}">
    <div class="monitor-index recent-file" *ngIf="launcher.isMawChrome">1</div>
    <div class="funkyradio-info col-md-5">
      <input (change)="changed()" type="checkbox" name="IsChecked" id="{{File.Id}}" [(ngModel)]="IsChecked" />
      <label class="d-flex align-items-center" for="{{File.Id}}">{{File.Title}}</label>
    </div>

    @if (playlistItem?.PlaylistItemLinks[0]?.isConverting) {
      <mat-icon (click)="playlistItem.PlaylistItemLinks[0]?.convertingRequest.unsubscribe()" class="ml-4 ctrl-icon"
        svgIcon="cancel_circle" matTooltip="Cancel converting"></mat-icon>
    }

    <mat-icon *ngIf="!playlistItem?.PlaylistItemLinks[0]?.isConverting" class="ml-4 ctrl-icon invisible" svgIcon="url_small">
      </mat-icon>

    <zoom-input *ngIf="launcher.isMawChrome && playlistItem?.PlaylistItemLinks[0].FileId"
      [source]="playlistItem.PlaylistItemLinks[0]" [item]="playlistItem"></zoom-input>

    <div
      class="emphasize pr-3 d-flex justify-content-start justify-content-md-end align-items-center">
      <p class="m-0">{{Date}} {{File.Size}} KB</p>
    </div>

    @if (playlistItem?.PlaylistItemLinks[0]?.isConverting) {
      <files-progress-bar [item]="playlistItem" [percentage]="playlistItem.percentage"
        [isRecentFilesTab]="true"></files-progress-bar>
    }

    <ng-container *ngFor="let source of playlistItem?.PlaylistItemLinks.slice(1); let i = index">
      <div class="files-group" *ngIf="IsChecked">
        <div class="monitor-index recent-file">{{ i + 2 }}</div>

        <ng-container *ngIf="source.IsFile; else url">
          <select class="col-md-5 files-list" [(ngModel)]="source.FileId" (change)="onSourceChanged(i + 1, $event)">
            <option class="d-none" selected [value]='source.FileId'>Select a file</option>
            <option *ngFor="let file of files" [ngValue]="file.Id">
              {{file.Title}}
            </option>
            <option *ngIf="!files || !files?.length" disabled>There are no files</option>
          </select>

          @if (source?.isConverting) {
            <mat-icon (click)="source.convertingRequest.unsubscribe()" class="ctrl-icon ml-4"
              svgIcon="cancel_circle" matTooltip="Cancel converting"></mat-icon>
          }
          @else {
            <mat-icon class="ml-4 ctrl-icon" (click)="onChangeField(i + 1)" svgIcon="url_small" matTooltip="Add url"></mat-icon>
          }
        </ng-container>

        <ng-template #url>
          <div class="title-input-wrapper recent-files col-md-5">
            <input #url class="title-input" placeholder="http://" id="URL" name="URL" [(ngModel)]="source.Link"
              (input)="onSourceChanged(i + 1, $event)">
          </div>

          <mat-icon class="ml-4 ctrl-icon" (click)="onChangeField(i + 1)" svgIcon="image" matTooltip="Add file"></mat-icon>
        </ng-template>

        <zoom-input *ngIf="source.Link || source.FileId"
          [source]="source" [item]="playlistItem"></zoom-input>

        <div *ngIf="!!source.FileId"
          class="emphasize pr-3 d-flex justify-content-start justify-content-md-end align-items-center">
          <p class="m-0">
            {{ (files | findFileById: source.FileId)?.DateCreated | dateToLocale}}
            {{ (files | findFileById: source.FileId)?.Size }} KB
          </p>
        </div>
      </div>
      @if (source?.isConverting) {
        <files-progress-bar [item]="playlistItem" [sourceIndex]="i + 1" [percentage]="source.percentage"
          [isRecentFilesTab]="true"></files-progress-bar>
      }
    </ng-container>
  </div>

  <div class="form-container options" *ngIf="playlistItem && ShowOptions">
    <div class="row w-50" [ngClass]="{ 'mcl-launcher': launcher.isMawChrome && playlistItem.PlaylistItemLinks[0]?.content }">
      <item-content-preview [item]="playlistItem" [selectedLauncher]="launcher"></item-content-preview>

      <div class="col-12" *ngIf="playlistItem.ExactVideoDuration">
        <mat-checkbox [disableRipple]="true" [(ngModel)]="playlistItem.useExactDuration" (change)="onExactDurationChange($event.checked)"
          name="UseExactDuration" class="light" matTooltip="Exact duration for a playlist item">Use Exact Duration
        </mat-checkbox>
      </div>

      <ng-container *ngIf="launcher.isMawChrome">
        <div class="col-12">
          <mat-checkbox [disableRipple]="true" [(ngModel)]="playlistItem.IsMuted" name="IsMuted"
            class="light" matTooltip="Item will be muted">Mute
          </mat-checkbox>
        </div>
        <div class="col-12">
          <mat-checkbox [disableRipple]="true" [(ngModel)]="playlistItem.IsContentStretched" name="IsContentStretched"
            class="light" matTooltip="Item content will be stretched" (change)="stretchContentChanged.emit(playlistItem)">
            Stretch content
          </mat-checkbox>
        </div>
      </ng-container>

      <div class="col-12">
        <app-launcher-features [launcherFeatures]="playlistItem.launcherFeatures"></app-launcher-features>
      </div>

      <div class="col-12" *ngIf="selectedLauncher && selectedLauncher.IsFullScreen">
        <mat-checkbox [disableRipple]="true" [(ngModel)]="playlistItem.OpenInFullScreen" name="OpenInFullScreen"
          class="light" matTooltip="Playlist item will be opened in full screen"> Open in Full Screen</mat-checkbox>
      </div>

    </div>

    <div class="form-group row invisible-border w-100 mb-2" *ngIf="playlistItem.PlaylistItemLinks.length > 1">
      <label for="Name" class="col-md-3" matTooltip="Playlist item name">Name</label>
      <input type="text" class="col-md-5 pl-3.5" placeholder="Playlist item name" [(ngModel)]="playlistItemName" id="Name"
        name="Name">
    </div>

    <div class="form-group row invisible-border w-100 mb-2" *ngIf="!playlist.IsAndroid">
      <label for="OpenWith" class="col-md-3" matTooltip="Application which will play a playlist item">Open
        With...</label>
      <mat-select class="col-md-5 pr-0" id="OpenWith" [(ngModel)]="selectedLauncher" name="launcher" panelClass="launcher-select"
        placeholder="Default Apps" (selectionChange)="onLauncherChanged()" [disableOptionCentering]="true">
        <mat-select-trigger>
          <img *ngIf="selectedLauncher?.LauncherImage; else icon" class="launcher-icon" [src]="iconsPath + selectedLauncher.LauncherImage"/>
          <ng-template #icon>
            <mat-icon class="launcher-icon" svgIcon="rocket_launch"></mat-icon>
          </ng-template>
          <span>{{ selectedLauncher?.LauncherTitle }}
            <ng-container *ngIf="selectedLauncher?.LauncherDescription">
              ({{ selectedLauncher.LauncherDescription }})
            </ng-container>
          </span>
        </mat-select-trigger>
        <mat-option value="image" *ngFor='let launcher of launchers | launcherSort' [value]="launcher">
          <img *ngIf="launcher?.LauncherImage; else icon" class="launcher-icon" [src]="iconsPath + launcher.LauncherImage"/>
          <ng-template #icon>
            <mat-icon class="launcher-icon" svgIcon="rocket_launch"></mat-icon>
          </ng-template>
          <span>{{ launcher.LauncherTitle }}
            <ng-container *ngIf="launcher.LauncherDescription">
              ({{ launcher.LauncherDescription }})
            </ng-container>
          </span>
        </mat-option>
        <mat-option *ngIf="!launchers || !launchers.length" disabled>There are no launchers</mat-option>
      </mat-select>

      <mat-icon svgIcon="rocket_launch" class="set-launcher-icon ctrl-icon" matTooltip="Set selected launcher for all items"
        *ngIf="showSetLauncherOption && checkedPlaylists > 1" (click)="setSelectedLauncherForAllItems.emit(selectedLauncher)">
      </mat-icon>

      <mcl-mode-select *ngIf="launcher.isMawChrome" [item]="playlistItem" [parentContainer]="container"
        [rss]="playlistItem.RssConfigs" (changeMode)="onChangeMode($event)">
      </mcl-mode-select>
    </div>

    <div class="form-group row w-100 mb-2">
      <label for="Duration" class="col-md-3" matTooltip="Playlist item duration">Set Duration</label>
      <div class="col-md-5 invisible-border duration-wrapper">
        <duration-picker [(duration)]="playlistItem.Duration" (dateTimeChanged)="onDurationChanged(playlistItem)">
        </duration-picker>
      </div>
      <mat-icon svgIcon="update_duration" class="update-duration-icon ctrl-icon" matTooltip="Set selected duration for all items"
        *ngIf="showApplyDurationOption && checkedPlaylists > 1" (click)="setDurationForAllItems.emit(playlistItem.Duration)">
      </mat-icon>
    </div>

    @if (launcher.isMawChrome || !hasRssForegroundItem) {
      <rss-source [playlist]="playlist" [playlistItem]="playlistItem" [className]="'w-100'"></rss-source>
    }

    <div class="form-group row invisible-border w-100" *ngIf="!launcher.isMawChrome">
      <label for="CustomParameters" class="col-md-3" matTooltip="Parameters for a playlist item">Custom
        Parameters</label>
      <input type="text" class="col-md-5" id="CustomParameters"
        [(ngModel)]="playlistItem.CustomParameters">
    </div>

    <div class="form-group row col-md-12 mt-3" *ngIf="playlist.IsAndroid">
      <playlist-item-advanced-options [item]="playlistItem"></playlist-item-advanced-options>
    </div>
  </div>
</div>
